import React, { useEffect, useState } from "react"
import style from "./variantCardWrapper.module.scss"
import VariantCard from "../variantCard/variantCard"

const VariantCardWrapper = (props) => {
    const [grouped, setGrouped] = useState("")
    const [open, setOpen] = useState(false)

    useEffect(() => {
        let array = [];
        if (props && props.data && props.data.mergeId) {
            props.data.mergeId.forEach((e, index) => {
                array.push("DKP -" + e);
            });
            let temp = array.join(" ,")
            setGrouped(temp)
        }
    }, [props])

    return (
        <div className={style.wrapper} style={{ marginBottom: "20px" }}>
            <VariantCard
                number={props.keys + 1}
                data={props.data}
                checked={props.checked}
                threeDotHandler={(tag, type, id) => props.threeDotHandler(tag, type, id)}
                productChecked={(color) => props.productChecked(color)}
                isEditing={props.isEditing}
                SubmitEdit={props.SubmitEdit}
                CalculateEdit={props.CalculateEdit}
                channelList={props.channelList}
            />
        </div>
    );
}

export default VariantCardWrapper;

